"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatEvent = exports.StatPlatform = void 0;
var StatPlatform;
(function (StatPlatform) {
    StatPlatform["ANDROID"] = "ANDROID";
    StatPlatform["IOS"] = "IOS";
    StatPlatform["DESKTOP"] = "DESKTOP";
    StatPlatform["OTHER"] = "OTHER";
})(StatPlatform = exports.StatPlatform || (exports.StatPlatform = {}));
var StatEvent;
(function (StatEvent) {
    StatEvent["CLICK"] = "CLICK";
    StatEvent["REDIRECT"] = "REDIRECT";
    StatEvent["APP_INSTALL"] = "APP_INSTALL";
    StatEvent["APP_FIRST_OPEN"] = "APP_FIRST_OPEN";
    StatEvent["APP_RE_OPEN"] = "APP_RE_OPEN";
})(StatEvent = exports.StatEvent || (exports.StatEvent = {}));
